// The specific reasons this module's backend gives, in the four languages.
//
// Two codes travel INSIDE an error and are not the code it is thrown with:
//
//   · `reasons` — what a generic refusal carries in `details.reason` or
//     `details.code` (`ConflictError(…, 'CONFLICT', { reason: 'ALREADY_CLOSED' })`).
//     errorMessage() says it from `errors.reasons.<REASON>` instead of the
//     generic «that record is no longer in the state you expected».
//   · `fields` — the code of each field of a ValidationError, said by
//     fieldErrors() from `errors.fields.<CODE>` instead of «not a valid value».
//
// Generic field codes (EMPTY, IN_THE_FUTURE, NOT_FOUND…) are the shell's and
// are not repeated here. platform/web/tests/errorReasons.test.js reads the
// backend and fails on a code without its four sentences, and on two
// modules saying one code differently (the shell merges them into one).

const errorReasons = {
  es: {
    reasons: {
      PORTAL_CUSTOMER_MISMATCH: 'Ese presupuesto ya es de otro cliente',
      PORTAL_QUOTE_CHANGED: 'El presupuesto cambió después de enviarlo; hay que volver a enviarlo antes de que el cliente lo acepte',
    },
    fields: {
      COLUMN_NOT_FOUND: 'Falta una columna que hace falta',
      TOO_MANY_ROWS: 'La hoja tiene demasiadas filas',
    },
  },
  ca: {
    reasons: {
      PORTAL_CUSTOMER_MISMATCH: 'Aquest pressupost ja és d’un altre client',
      PORTAL_QUOTE_CHANGED: 'El pressupost ha canviat després d’enviar-lo; cal tornar-lo a enviar abans que el client l’accepti',
    },
    fields: {
      COLUMN_NOT_FOUND: 'Falta una columna que cal',
      TOO_MANY_ROWS: 'El full té massa files',
    },
  },
  en: {
    reasons: {
      PORTAL_CUSTOMER_MISMATCH: 'That quote belongs to another customer now',
      PORTAL_QUOTE_CHANGED: 'The quote changed after it was sent; send it again before the customer can accept it',
    },
    fields: {
      COLUMN_NOT_FOUND: 'A column it needs is missing',
      TOO_MANY_ROWS: 'The sheet has too many rows',
    },
  },
  fr: {
    reasons: {
      PORTAL_CUSTOMER_MISMATCH: 'Ce devis appartient désormais à un autre client',
      PORTAL_QUOTE_CHANGED: 'Le devis a changé après son envoi ; il faut le renvoyer avant que le client puisse l’accepter',
    },
    fields: {
      COLUMN_NOT_FOUND: 'Une colonne nécessaire manque',
      TOO_MANY_ROWS: 'La feuille a trop de lignes',
    },
  },
}

/** The module's catalogue with these hung from `errors`, locale by locale. */
export function withErrorReasons(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    const own = errorReasons[locale] ?? {}
    merged[locale] = {
      ...catalogue,
      errors: {
        ...catalogue.errors,
        reasons: { ...catalogue.errors?.reasons, ...own.reasons },
        fields: { ...catalogue.errors?.fields, ...own.fields },
      },
    }
  }
  return merged
}

export default errorReasons
